import { isEmpty, isNil } from 'rambda';

export const isNilEmpty = (v: unknown) => isNil(v) || isEmpty(v);

export const isNotNilEmpty = <T>(v: T): v is NonNullable<T> => !isNilEmpty(v);
